var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:[
  { 'app--logged': _vm.loggedIn && _vm.menuVisible },
  { 'app--menu': _vm.loggedIn && _vm.menuVisible && !_vm.hasMainMenuOpen },
  { 'route--without-menu': _vm.loggedIn && !_vm.menuVisible },
  ("route--" + _vm.routeName)
]},[(_vm.loggedIn)?_c('Navbar'):_vm._e(),_c('v-main',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1),_c('Snackbar'),_c('CorpGlobalLoader'),_c('CorpWatermark'),_c('PreventCopyAndPasteText'),_c('BrowserCompatibilityDialog'),_c('ConnectionMonitoring'),_c('WebChat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }